import Styled from 'styled-components';
import { Headline } from '@amount/frontend-components';

export const GreetingHeadline = Styled(Headline)`
  margin-bottom: 0;
`;
